import PropTypes from 'prop-types';
import React from 'react';
import GreyhoundRacingRacecardRunner from "./GreyhoundRacingRacecardRunner";

export default function GreyhoundRacingRacecardNonRunners(props) {

  if (props.nonRunners && props.nonRunners.length) {
    return (
      <section>
        <div className="gh-racing-racecard-section-header">
          <h4>Non Runners</h4>
        </div>
        {
          props.nonRunners.map(nonRunner => {
            return <GreyhoundRacingRacecardRunner
              runner={nonRunner}
              key={nonRunner.key}
            />
          })
        }
      </section>
    )
  } else {
    return <section />
  }
}

GreyhoundRacingRacecardNonRunners.propTypes = {
  nonRunners: PropTypes.arrayOf(PropTypes.object)
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardNonRunners.js